import styled from 'styled-components';

interface BoxStyledProps {
  $altura: number;
}

interface Props {
  $largura?: number;
  $comprimento?: number;
  $distanciaportico?: number;
  $espacamentos?: number;
}

export const CotaAlturaElevacao = styled.div<BoxStyledProps>`
  position: absolute;
  top: 50%;
  left: 70px;

  &:before {
    content: '${({ $altura }) => $altura}m';
    font-size: 12px;
    position: absolute;
    rotate: 270deg;
  }
`;

export const IndicadorAguaBaixo = styled.div`
  position: absolute;
  left: 50%;
  top: 60%;
  transform: translateX(-50%);
  z-index: 999;
`;

export const IndicadorAguaCima = styled.div`
  position: absolute;
  left: 50%;
  top: 15%;
  transform: translateX(-50%);
  z-index: 999;
`;

export const CotaLarguraElevavacao = styled.div`
  position: absolute;
  background-color: transparent;
  font-size: 12px;
  left: 50%;
  top: calc(50% - 40px);
`;

export const RetanguloStyled = styled.div<Props>`
  display: flex;
  flex-direction: row;
  background-color: #ededed;
  height: ${({ $largura }) => `${$largura * 8}px`};
  min-height: 192px;
  max-height: 25rem;
  min-width: fit-content;
  position: relative;

  &:first-child {
    border-left: 2px solid;
  }

  &:last-child {
    border-right: 2px solid;
  }
`;

export const RetanguloPortico = styled.div<Props>`
  &:not(:last-child) {
    border-right: 2px solid #b3b3b3;
  }
  background: transparent;
  border-top: 2px solid;
  border-bottom: 2px solid;

  height: ${({ $largura }) => `${$largura * 8}px`};
  min-height: 12rem;
  max-height: 25rem;

  min-width: ${({ $espacamentos }) =>
    $espacamentos
      ? $espacamentos <= 10
        ? '3rem'
        : $espacamentos > 10 && $espacamentos < 20
          ? '2.5rem'
          : '1.5rem'
      : '1.5rem'};

  position: relative;

  span {
    position: absolute;
    top: -32px;
    left: 50%;
    transform: translateX(-50%);
    background: transparent;
    padding: 0 5px;
    font-size: 10px;
  }
`;

export const TrianguloIconContainer = styled.div`
  width: 32px;
  height: 32px;
  position: absolute;
  top: calc(50% - 16px);
  left: -80px;
  transform: translateX(-50%);
  transform: rotate(90deg);
`;

export const CotaLargura = styled.span`
  position: absolute;
  top: calc(50% - 8px);
  left: -32px;
  transform: translateX(-50%);
  background: transparent;
  font-size: 10px;
`;

export const CotaComprimento = styled.span<Props>`
  position: absolute;
  left: ${({ $espacamentos }) => ($espacamentos < 3 ? 'calc(50%)' : 'calc(50% - 8px)')};
  bottom: -32px;
  transform: translateX(-50%);
  background: transparent;
  font-size: 10px;
`;

export const Dot = styled.div`
  width: 3px !important;
  height: 6.5px;
  background-color: black;
  position: absolute;
  right: -0.03125rem;
  transform: translateX(50%);
`;

export const DotTop = styled(Dot)`
  top: 0;
`;

export const DotBottom = styled(Dot)`
  bottom: 0;
`;

export const DotTopFirst = styled(Dot)`
  top: 0;
  background-color: black;
  left: -0.13125rem;
`;

export const DotBottomFirst = styled(Dot)`
  bottom: 0;
  background-color: black;
  left: -0.13125rem;
`;

export const CenterLine = styled.div`
  position: relative;
  width: 100%;
  height: 2px;
  top: 50%;
  z-index: 0;
  background-color: #b3b3b3;
`;

export const BottomLine = styled.div`
  position: relative;
  width: 100%;
  height: 2px;
  top: 25%;
  z-index: 0;
  background-color: #b3b3b3;
`;

export const TopLine = styled.div`
  position: relative;
  width: 100%;
  height: 2px;
  top: 75%;
  z-index: 0;
  background-color: #b3b3b3;
`;
